import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectOngoingPlayerProfileInfo } from "../../selectors/selectOngoingPlayerProfileInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonDelete } from "../generic/common/ButtonDelete";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopInfoInvitePlayer } from "./actionCoop";
export var _DialogCoopInvite = function (_a) {
    var onClose = _a.onClose, onClickInvite = _a.onClickInvite, coopId = _a.coopId, playerId = _a.playerId, playerNameToInvite = _a.playerNameToInvite, playerIdToInvite = _a.playerIdToInvite;
    var replacements = new Map([[ReplacementLoca.zero_0, playerNameToInvite]]);
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.confirmation, onClose: onClose, className: IdStyles.ModalBackgroundInfo + " DialogCoopConfirm" },
        React.createElement("div", { className: "w100 h100 flex flex--guts DialogCoopConfirm__content" },
            React.createElement("div", { className: "DialogCoopConfirm__question" },
                React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.coopInviteConfirmationDialog_desc, replacements: replacements })),
            React.createElement("div", { className: "w100 DialogCoopConfirm__confirm-or-cancel" },
                React.createElement(ButtonDelete, { onClick: onClose },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.cancel })),
                React.createElement(ButtonPrimary, { onClick: function () { return onClickInvite(playerId, coopId, playerIdToInvite); } },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.invite }))))));
};
var mapState = function (state) {
    var current = selectPlayerInfo(state);
    var coopId = current.coopId, playerId = current.playerId;
    var toInvite = selectOngoingPlayerProfileInfo(state);
    var playerIdToInvite = toInvite.id, playerNameToInvite = toInvite.name;
    return {
        coopId: coopId,
        playerId: playerId,
        playerIdToInvite: playerIdToInvite,
        playerNameToInvite: playerNameToInvite,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClickInvite: function (playerId, coopId, playerIdToInvite) {
        dispatch(actionCoopInfoInvitePlayer(playerId, coopId, playerIdToInvite));
        dispatch(actionModalClose(IdModal.CoopInvite));
    },
    onClose: function () { return dispatch(actionModalClose(IdModal.CoopInvite)); },
}); };
export var DialogCoopInvite = connect(mapState, mapDispatch)(_DialogCoopInvite);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogInvite.tsx
// module id = 2570
// module chunks = 3